import { Project } from '@/api/generated/models'
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react'

interface ProjectContextType {
  selectedProject: Project | null
  setSelectedProject: (project: Project | null) => void
}

interface ProjectProviderProps {
  children: ReactNode
}

const ProjectContext = createContext<ProjectContextType | undefined>(undefined)

export const ProjectProvider: React.FC<ProjectProviderProps> = ({
  children,
}) => {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null)

  useEffect(() => {
    const storedProject = localStorage.getItem('project')

    if (storedProject && storedProject !== 'null') {
      setSelectedProject(JSON.parse(storedProject))
    }
  }, [])

  useEffect(() => {
    if (selectedProject) {
      localStorage.setItem('project', JSON.stringify(selectedProject))
    } else {
      localStorage.removeItem('project') // Remove instead of setting to "null"
    }
  }, [selectedProject])

  return (
    <ProjectContext.Provider value={{ selectedProject, setSelectedProject }}>
      {children}
    </ProjectContext.Provider>
  )
}

export const useProjectContext = (): ProjectContextType => {
  const context = useContext(ProjectContext)

  if (context === undefined) {
    throw new Error('useProjectContext must be used within a ProjectProvider')
  }

  return context
}
